// Frontend mirror of workers/src/lib/project-name.ts. Kept identical so
// the new-project modal preview matches what the backend writes on save.

export type ClientName = {
  first?: string | null
  last?: string | null
}

function clean(s: string | null | undefined): string {
  return (s ?? '').trim()
}

function hasName(c: ClientName | null | undefined): boolean {
  return !!(c && (clean(c.first) || clean(c.last)))
}

export function generateProjectName(
  client1: ClientName | null,
  client2: ClientName | null
): string | null {
  const c1 = client1 && hasName(client1) ? client1 : null
  const c2 = client2 && hasName(client2) ? client2 : null
  if (!c1 && !c2) return null

  const c1Last = clean(c1?.last)
  const c2Last = clean(c2?.last)

  if (c1 && !c2) {
    if (!c1Last) return null
    return `${c1Last} Build`
  }
  if (!c1 && c2) {
    if (!c2Last) return null
    return `${c2Last} Build`
  }
  const f1 = clean(c1!.first)
  const f2 = clean(c2!.first)
  if (c1Last && c2Last) {
    if (c1Last.toLowerCase() === c2Last.toLowerCase()) {
      if (f1 && f2) return `${f1} and ${f2} ${c1Last} Build`
      return `${c1Last} Build`
    }
    return `${c1Last}-${c2Last} Build`
  }
  return `${c1Last || c2Last} Build`
}
